import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  OutputEmitterRef,
  Signal,
  computed,
  input,
  output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'mp-selection-tile',
  templateUrl: './selection-tile.component.html',
  styleUrl: './selection-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatCard, MatCardContent, MatIconButton],
})
export class SelectionTileComponent {
  readonly allowEdit: InputSignal<boolean> = input<boolean>(false);
  readonly allowRemove: InputSignal<boolean> = input<boolean>(false);

  readonly isClickable: InputSignal<boolean> = input<boolean>(true);
  readonly isReadOnly: InputSignal<boolean> = input<boolean>(false);

  readonly hasValue: InputSignal<boolean> = input<boolean>(false);

  readonly selected: OutputEmitterRef<void> = output<void>();
  readonly removed: OutputEmitterRef<void> = output<void>();

  protected readonly isTileClickable: Signal<boolean> = computed(() => !this.isReadOnly() && this.isClickable());

  protected readonly actionIcon: Signal<string | undefined> = computed(() => {
    if (!this.hasValue()) {
      return 'add';
    }

    if (this.allowEdit()) {
      return 'edit';
    }

    return undefined;
  });

  protected readonly showRemoveButton: Signal<boolean> = computed(
    () => !this.isReadOnly() && this.allowRemove() && this.hasValue(),
  );
  protected readonly showActionButton: Signal<boolean> = computed(
    () => !this.isReadOnly() && this.isTileClickable() && !!this.actionIcon(),
  );

  emitSelectEvent(): void {
    if (!this.isTileClickable()) {
      return;
    }
    this.selected.emit();
  }
}
